import { useQuery } from "@tanstack/react-query";

import { marketplaceApi } from "@/features/marketplace/services/marketplace.api";

export function useCategories() {
  return useQuery({
    queryKey: ["categories"],
    queryFn: marketplaceApi.getCategories,
    // Categories change far less often than a product feed — an hour-long
    // staleTime avoids refetching them on every navigation back to Home.
    staleTime: 60 * 60_000,
  });
}
